import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { Status } from '../../models/status';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { UntypedFormControl } from '@angular/forms';
import { StatusHelper } from '../../helpers/status-helper';
import { MatSelectChange } from '@angular/material/select';
import { SelectionArguments } from '../../models/selection-arguments';
import { ControlBase } from '../control-base';

@Component({
    selector: 'ldw-status-select',
    templateUrl: './status-select.component.html',
    styleUrls: ['./status-select.component.css'],
    standalone: false
})
export class StatusSelectComponent extends ControlBase implements OnInit {
  private webDokuService = inject(WebdokuService);

  @Output() statusChanged: EventEmitter<SelectionArguments> = new EventEmitter();
  states: Status[];

  constructor() {
    super();
    const webDokuService = this.webDokuService;

    this.states = webDokuService.currentStatusValues;
  }

  ngOnInit(): void {
    if (this.form != undefined) {
      this.internalControl = new UntypedFormControl(this.initialValue);
      this.form.addControl(this.controlName, this.internalControl);
    }
  }

  getSelectedItemStyle(): string {
    const value = this.internalControl?.value;
    if (value == undefined || value == '') {
      return '';
    }

    const item = this.states.find(x => x.id == value);
    if (item != undefined) {
      return StatusHelper.getItemStyle(item);
    }
    return '';
  }

  getItemStyle(state: Status): string {
    return StatusHelper.getItemStyle(state);
  }

  changed(event: MatSelectChange) {
    if (event.value == this.initialValue) {
      return;
    }
    const args = new SelectionArguments();
    args.id = event.value;
    this.statusChanged.emit(args);
    this.initialValue = event.value;
  }

}
